'use client';

import {
  GiftRewardNames,
  getGiftRewardText,
  type GiftReward,
} from '@eliadmin/core/src/components/product/detail/gift-reward';

type Props = { locale: string; amount: string; hasCurrentTier: boolean; reward?: GiftReward };
function getCopy(locale: string, amount: string) {
  const language = locale.toLowerCase().replaceAll('_', '-').split('-')[0];
  return language === 'sk'
    ? {
        prefix: `Nakúpte ešte za ${amount}`,
        gift: 'a vyberte si darček.',
        next: 'a rozšírte si výber darčekov.',
        named: 'a budete si môcť vybrať aj',
      }
    : language === 'cs' || language === 'cz'
      ? {
          prefix: `Nakupte ještě za ${amount}`,
          gift: 'a vyberte si dárek.',
          next: 'a rozšiřte si výběr dárků.',
          named: 'a budete si moci vybrat také',
        }
      : {
          prefix: `Spend ${amount} more`,
          gift: 'and choose your gift.',
          next: 'for more gift options.',
          named: 'and you can also choose',
        };
}

export function getGiftNextCaptionText({ locale, amount, hasCurrentTier, reward }: Props) {
  const copy = getCopy(locale, amount);
  return `${copy.prefix} ${!hasCurrentTier ? copy.gift : reward ? `${copy.named} ${getGiftRewardText(reward, '')}.` : copy.next}`;
}

export function GiftNextRewardCaption({ locale, amount, hasCurrentTier, reward }: Props) {
  const copy = getCopy(locale, amount);
  return (
    <>
      {copy.prefix}{' '}
      {!hasCurrentTier ? (
        copy.gift
      ) : reward ? (
        <>
          {copy.named} <GiftRewardNames reward={reward} fallback={copy.next} />.
        </>
      ) : (
        copy.next
      )}
    </>
  );
}
